import { Order } from "../../store/slices/order/types";
import React from "react";
import BaseStatusLabel from "../base/BaseStatusLabel";
import moment from "moment";
import { appointmentLabels, operationLabels } from "../../data/utils";
import { BaseButton } from "../base";
import { OperationType } from "../../enums/operation-type.enum";
import GreenDotIcon from "../../assets/img/GreenDotIcon.svg";
import { useAppSelector } from "../../store";
import { OrderStatus } from "../../enums/order-status.enum";

export type OrderCardProp = {
  orderDetails: Order | null;
  showResult: boolean;
  setShowResult: React.Dispatch<React.SetStateAction<boolean>>;
};
const OrderCard: React.FC<OrderCardProp> = ({
  orderDetails,
  showResult,
  setShowResult,
}) => {
  const { dashboardInfo } = useAppSelector(
    (state) => state.organisationReducer
  );
  return (
    <div className="bg-[#F2F6FA] rounded-[1rem]">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 p-8">
        <div className="">
          <p className="mb-1 font-bold text-[#0C4654] text-[0.875rem]">
            Order ID
          </p>
          <p className="font-normal text-[0.875rem]">
            {orderDetails?.uniqueId || "----------"}
          </p>
        </div>

        <div className="">
          <p className="mb-1 font-bold text-[#0C4654] text-[0.875rem]">
            Order Status
          </p>
          <div className="w-1/2">
            {orderDetails?.orderStatus ? (
              <BaseStatusLabel status={orderDetails?.orderStatus} />
            ) : (
              "----------"
            )}
          </div>
        </div>

        <div className="">
          <p className="mb-1 font-bold text-[#0C4654] text-[0.875rem]">
            Order Type
          </p>
          <div className="font-normal text-[0.875rem]">
            {operationLabels
              .find((label) => label.name === orderDetails?.operationType)
              ?.label.toUpperCase() || "----------"}
          </div>
        </div>

        <div className="">
          <p className="mb-1 font-bold text-[#0C4654] text-[0.875rem]">
            Appointment Type
          </p>
          <p className="font-normal text-[0.875rem]">
            {appointmentLabels
              .find(
                (label) =>
                  label.name === orderDetails?.appointments[0]?.appointmentType
              )
              ?.label.toUpperCase() || "----------"}
          </p>
        </div>

        <div className="">
          <p className="mb-1 font-bold text-[#0C4654] text-[0.875rem]">
            Appointment Date
          </p>
          <p className="font-normal text-[0.875rem]">
            {orderDetails?.appointments[0]?.proposedAppointmentDate
              ? moment(
                  orderDetails?.appointments[0]?.proposedAppointmentDate
                ).format("DD-MM-YYYY")
              : "----------"}
          </p>
        </div>

        <div className="">
          <p className="mb-1 font-bold text-[#0C4654] text-[0.875rem]">
            Appointment Time
          </p>
          <p className="font-normal text-[0.875rem]">
            {orderDetails?.appointments[0]?.proposedAppointmentTime ||
              "----------"}
          </p>
        </div>

        <div className="cols-span-3">
          <p className="mb-1 font-bold text-[#0C4654] text-[0.875rem]">
            Appointment Address
          </p>
          <p className="font-normal text-[0.875rem]">
            {orderDetails?.appointments[0]?.lineOfAddress || "----------"}
          </p>
        </div>
      </div>
      <div className="px-8 py-4 w-full">
        <p className="mb-2 font-bold text-[#0C4654] text-[0.875rem]">
          Products Ordered
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4 text-center">
          {orderDetails?.products.map((product) => (
            <div key={product._id} className="flex items-center justify-center font-normal bg-white py-2 px-4 rounded-full border text-[0.875rem]">
              <img
                src={GreenDotIcon}
                alt="green dot icon"
                className="w-2 h-2"
              />
              <p className="mx-2">{product?.name}</p>
            </div>
          ))}
        </div>
      </div>
      {orderDetails?.operationType === OperationType.LabTest &&
       orderDetails?.orderStatus === OrderStatus.ResultAvailable && (
          <div className="px-8 py-4 w-full">
            <BaseButton
              type="button"
              text={showResult ? "Hide Result" : "View Result"}
              click={() => setShowResult(!showResult)}
              variant={showResult ? "neutral" : "primary"}
              styles="px-4 !rounded-lg !font-semibold"
            />
          </div>
        )}
    </div>
  );
};

export default OrderCard;
